import filter from 'lodash/filter'
import React, {Component} from 'react';
import {connect} from '~/redux/connect';
import isEqual from 'lodash/isEqual';
import {
    presentAllMessages, presentAllErrors
} from "~/stateGetter";
import orderBy from 'lodash/orderBy';
import {modelActionsCreator} from "~/actions/model_actions";
import getConfig from "~/config";
import MessageList from "~/ui/components/MessageList/MessageList";

const areStatePropsEqual = (props, prevProps) => {
    return isEqual(props, prevProps);
};

const RXMessageList = connect(
    (state, {modelId}) => {
        return {
            messages: presentAllMessages(state, modelId, getConfig().messageSources),
            errors: presentAllErrors(state, modelId, getConfig().errorSources),
        }
    },
    (dispatch, {modelId}) => {
        let { hideMessages } = modelActionsCreator(modelId);

        return {
            hideMessages: () => dispatch(hideMessages())
        };
    },

    ({ messages, errors, ...otherProps }, dispatcher, {filterMessages, ...otherOwnProps}) => {
        let filterTheMessages = (messages) => {
            // console.log('before filter', messages);

            messages = filter(messages, (message) => message && message.message.length);
            messages = filterMessages ? filterMessages(messages) : messages;

            // console.log('after filter', messages);

            return messages;
        };

        return {
            ...otherProps,
            ...otherOwnProps,
            ...dispatcher,
            messages: orderBy(filterTheMessages([
                ...messages,
                ...errors
            ]),'type'),
        }
    }, { areStatePropsEqual }
)(MessageList);

export default RXMessageList;